import React from 'react';
import Modal from './Modal';
import Button from '../Button/Button';
import { colors } from '../../constants/colors';

/** ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð½ÐµÐ¾Ð±ÑÐ°ÑÐ¸Ð¼Ð¾Ð³Ð¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ: ÐºÐ¾ÑÐ¾ÑÐºÐ¸Ð¹ Ð²Ð¾Ð¿ÑÐ¾Ñ Ð¸ Ð´Ð²Ðµ ÐºÐ½Ð¾Ð¿ÐºÐ¸. */
const ConfirmModal = ({
  isOpen,
  onClose,
  title,
  text,
  confirmText = 'Ð£Ð´Ð°Ð»Ð¸ÑÑ',
  cancelText = 'ÐÑÐ¼ÐµÐ½Ð°',
  loading,
  onConfirm,
}) => (
  <Modal isOpen={isOpen} onRequestClose={onClose} title={title} width="480px" contentStyle={{ top: '22%', bottom: 'auto' }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <p style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 14, color: colors.blackPearl }}>{text}</p>
      <div style={{ display: 'flex', gap: 12 }}>
        <Button text={confirmText} fill onClick={onConfirm} disabled={loading} />
        <Button text={cancelText} onClick={onClose} disabled={loading} />
      </div>
    </div>
  </Modal>
);

export default ConfirmModal;
